import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['profile']),

    /**
     * @return {String} - seguro, segura, segur@
     */
    wordSure() {
      return this.profile && this.profile.gender
        ? this.transformWordGender('segura', this.profile.gender)
        : 'segur@'
    },
  },
  methods: {
    /**
     * Transforma el tipo de usuario de la bd, a un texto mas agradable segun el idioma
     * @param {String} type Tipo de usuario
     * @return {String} Devuelve el tipo de usuario transformado a español
     */
    transformTypeUser(type) {
      switch (type) {
        // type a Español
        case 'agent':
          return 'Agente'
        case 'supervisor':
          return 'Supervisor'
        case 'supervisor_agent':
          return 'Supervisor'
        case 'admin':
          return 'Administrador'
        case 'admin_agent':
          return 'Administrador'
        case 'securitec':
          return 'Superusuario'
        // Español a type
        case 'Agente':
          return 'agent'
        case 'Supervisor':
          return 'supervisor'
        case 'Administrador':
          return 'admin'
        default:
          return null
      }
    },
    /**
     * Transforma el nombre de un canal de la bd, respetando las mayúsculas segun su nombre oficial
     * @param {String} channel [whatsapp,instagram,...] Nombre del canal
     * @return {String} Devuelve el nombre del canal, pero respetando las mayúsculas segun su nombre oficial
     */
    transformApiChannel(channel) {
      switch (channel) {
        case 'whatsapp':
          return 'WhatsApp'
        case 'messenger':
          return 'Messenger'
        case 'telegram':
          return 'Telegram'
        case 'instagram':
          return 'Instagram'
        case 'webchat':
          return 'Webchat'
        default:
          return null
      }
    },
    /**
     * Cambiar letra de una palabra según el género que le corresponde
     * @param {String}        word Palabra para cambiar según el género
     * @param {String}        [gender=null] Género [male, female, null]
     * @param {Number}        index Índice de la letra que se modificará - Opcional (Por defecto tomará al último)
     * @param {Array[String]} values Valores por los que se reemplazarán las letras de las palabras - Opcional (Por defecto se reemplazarán por "o" y "a" respectivamente)
     * @returns {String} palabra formateada
     */
    transformWordGender(word, gender = null, index, values) {
      // word y gender son obligatorios
      // Validación de entradas
      if (!word) throw new Error('word required')
      if (!['male', 'female', null].includes(gender))
        throw new Error('gender only must be male, female or null')
      if (!values) values = ['o', 'a', '@']
      if (!index) index = word.length - 1
      // Comparaciones
      let split = word.split('')
      split[index] =
        gender === 'male'
          ? values[0]
          : gender === 'female'
          ? values[1]
          : values[2]
      return split.join('')
    },
    /**
     * Muestra el nombre del género en un idioma a partir de una key
     * @param {String} gender [male,female]
     * @param {String} [lang='es']
     * @returns {String}
     */
    transforGender(gender, lang = 'es') {
      switch (lang) {
        case 'es': {
          if (gender === 'male') return 'Masculino'
          else if (gender === 'female') return 'Femenino'
          break
        }
      }
      throw Error(`gender: ${gender} not supported`)
    },
    /**
     * Transforma los dias a partir de los indices que se pasan y devuelve la abreviación y el nombre del día
     * @param {Number[]} indexDays - array de los indices de los dias (del 0 al 6)
     * @return {Object[]} [{ abreviation, day }]
     */
    transformIndexDays(indexDays) {
      const days = [
        { abreviation: 'Do', day: 'Domingo' },
        { abreviation: 'Lu', day: 'Lunes' },
        { abreviation: 'Ma', day: 'Martes' },
        { abreviation: 'Mi', day: 'Miércoles' },
        { abreviation: 'Ju', day: 'Jueves' },
        { abreviation: 'Vi', day: 'Viernes' },
        { abreviation: 'Sa', day: 'Sábado' },
      ]
      return days.filter((day, index) => indexDays.includes(index))
    },
    /**
     * Transforma el nombre de los planes de acuerdo al tipo
     * @param {String} key
     * @param {String} type - uppercase, lowercase, capitalize
     * @returns {String}
     */
    transformNamePlan(key, type) {
      let namePlan = null
      switch (key) {
        case 'free':
          namePlan = 'FREE'
          break
        case 'advanced':
          namePlan = 'ADVANCED'
          break
        case 'business':
          namePlan = 'BUSINESS'
          break
        case 'enterprise':
          namePlan = 'ENTERPRISE'
      }
      if (type === 'lowercase') return namePlan.toLowerCase()
      else if (type === 'capitalize')
        return (
          namePlan.charAt(0).toUpperCase() + namePlan.toLowerCase().slice(1)
        )
      else return namePlan.toUpperCase()
    },
    /**
     * Transforma una palabra a lowercase, uppercase, capitalize
     * @param {String} word
     * @param {String} type lowercase, uppercase, capitalize
     * @return {String}
     */
    transformWord(word, type) {
      switch (type) {
        case 'lowercase':
          return word.toLowerCase()
        case 'capitalize':
          return word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)
        case 'uppercase':
          return word.toUpperCase()
        default:
          return word
      }
    },
  },
}
